"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGrantTypeValidator = void 0;
exports.nullValidator = nullValidator;
var _utils = require("./utils");
var openAMGrantTypeValidator = function openAMGrantTypeValidator(_ref) {
  var form = _ref.form,
    _ref$isGrantTypesDirt = _ref.isGrantTypesDirty,
    isGrantTypesDirty = _ref$isGrantTypesDirt === void 0 ? true : _ref$isGrantTypesDirt,
    _ref$isGrantTypesRequ = _ref.isGrantTypesRequired,
    isGrantTypesRequired = _ref$isGrantTypesRequ === void 0 ? true : _ref$isGrantTypesRequ;
  return {
    validate: function validate() {
      if (!isGrantTypesDirty || !isGrantTypesRequired) {
        return true;
      }
      var clientCredentials = form[(0, _utils.getGrantTypeValueKey)('client_credentials')];
      var authorizationCode = form[(0, _utils.getGrantTypeValueKey)('authorization_code')];
      return clientCredentials || authorizationCode;
    },
    message: 'Please check either "Authorization Code" or "Client Credentials"'
  };
};
var atLeastOneGrantTypeSelectedValidator = function atLeastOneGrantTypeSelectedValidator(_ref2) {
  var form = _ref2.form,
    grantTypes = _ref2.grantTypes,
    _ref2$isGrantTypesDir = _ref2.isGrantTypesDirty,
    isGrantTypesDirty = _ref2$isGrantTypesDir === void 0 ? true : _ref2$isGrantTypesDir,
    _ref2$isGrantTypesReq = _ref2.isGrantTypesRequired,
    isGrantTypesRequired = _ref2$isGrantTypesReq === void 0 ? true : _ref2$isGrantTypesReq;
  return {
    validate: function validate() {
      if (!isGrantTypesDirty || !isGrantTypesRequired) {
        return true;
      }
      var selectedGrantTypes = grantTypes.filter(function (grantType) {
        return form[(0, _utils.getGrantTypeValueKey)(grantType.name)];
      });
      return selectedGrantTypes.length !== 0;
    },
    message: 'Please check at least one grant type'
  };
};
var getGrantTypeValidator = exports.getGrantTypeValidator = function getGrantTypeValidator(_ref3) {
  var identityManagementType = _ref3.identityManagementType;
  return identityManagementType === 'openam' ? openAMGrantTypeValidator : atLeastOneGrantTypeSelectedValidator;
};
function nullValidator() {
  var validator = {
    validate: function validate() {
      return true;
    },
    message: ''
  };
  return {
    nullValidator: validator
  };
}
//# sourceMappingURL=validations.js.map